import React from 'react';
import Chart from 'react-apexcharts';

const data = {
  series: [
    {
      name: 'Market Share',
      data: [12, 9, 8, 6, 5, 4],
    },
    {
      name: 'Win Rate',
      data: [68, 72, 65, 58, 52, 48],
    },
  ],
  options: {
    chart: {
      type: 'bar',
      height: 300,
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false, // Changed to vertical bars
        columnWidth: '55%',
        endingShape: 'rounded',
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => `${val}%`,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: [
        'Your Company',
        'Competitor A',
        'Competitor B',
        'Competitor C',
        'Competitor D',
        'Competitor E',
      ],
      labels: {
        rotate: -45,
        trim: false,
      },
    },
    yaxis: {
      title: {
        text: 'Percentage (%)',
      },
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val}%`,
      },
    },
    fill: {
      opacity: 1,
    },
    colors: ['#8884d8', '#82ca9d'],
    legend: {
      position: 'top',
      horizontalAlign: 'left',
    },
  },
};

export function CompetitorAnalysis() {
  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h3 className="text-lg font-medium text-gray-900">Competitor Analysis</h3>
      <div className="mt-2">
        <div className="h-[300px]">
          <Chart
            options={data.options as any}
            series={data.series}
            type="bar"
            height={300}
          />
        </div>
      </div>
    </div>
  );
}